// extracted by mini-css-extract-plugin
module.exports = {"vPrimary1":"#00a8e2","footer":"FooterLK_footer__1RuwB","copyright":"FooterLK_copyright__C4Gdx","copyrightIcon":"FooterLK_copyrightIcon__38xcy"};